import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/api";
import { useLang } from "@/i18n";

const AuthContext = createContext(null);

export const homeFor = (role) =>
  role === "admin" ? "/admin" : role === "dsa" ? "/dsa" : "/dashboard";

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = logged out
  const { setLang } = useLang();

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data);
        if (r.data.lang) setLang(r.data.lang);
      })
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    if (data.lang) setLang(data.lang);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      /* ignore */
    }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
